// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__4yLPB","pagination":"Pagination_pagination__+0AuO","defaultLink":"Pagination_defaultLink__sazg9","active":"Pagination_active__g2eo+"};